import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";

import "./index.css";
import App from "./containers/App/App.js";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import Spinner from "./components/Spinner/index.js";
import logo from "./assets/logo.svg";

const persistor = persistStore(store);

const LoadingScreen = (
  <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 animate-bounce">
    <img className="h-16 w-16" src={logo} alt="Ticolitas Logo" />
    <div><Spinner /></div>
  </div>
);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <PersistGate loading={LoadingScreen} persistor={persistor}>
        <App />
      </PersistGate>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// Registrar Service Worker para manejo de cache
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado:', registration);

        // Verificar actualizaciones periódicamente
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Nueva versión disponible, notificar al usuario
              console.log('Nueva versión disponible. Recargando...');
              window.location.reload();
            }
          });
        });
      })
      .catch((error) => {
        console.log('Error al registrar Service Worker:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
